import partial from 'lodash.partial';
import { rechargeApiRequest } from '../utils/request.js';
import { bulkSubscriptionCreateMapper, subscriptionMapperOldToNew, bulkSubscriptionUpdateMapper } from '../mappers/subscription.js';
async function getSubscription(session, id, options) {
  const {
    subscription
  } = await rechargeApiRequest("get", `/subscriptions`, {
    id,
    query: {
      include: options?.include
    }
  }, session);
  return subscription;
}
function listSubscriptions(session, query) {
  return rechargeApiRequest("get", `/subscriptions`, {
    query
  }, session);
}
async function createSubscription(session, createRequest, query) {
  const {
    subscription
  } = await rechargeApiRequest("post", `/subscriptions`, {
    data: createRequest,
    query
  }, session);
  return subscription;
}
async function updateSubscription(session, id, updateRequest, query) {
  const {
    subscription
  } = await rechargeApiRequest("put", `/subscriptions`, {
    id,
    data: updateRequest,
    query
  }, session);
  return subscription;
}
async function updateSubscriptionChargeDate(session, id, date, query) {
  const {
    subscription
  } = await rechargeApiRequest("post", `/subscriptions/${id}/set_next_charge_date`, {
    data: {
      date
    },
    query
  }, session);
  return subscription;
}
async function updateSubscriptionAddress(session, id, address_id) {
  const {
    subscription
  } = await rechargeApiRequest("post", `/subscriptions/${id}/change_address`, {
    data: {
      address_id
    }
  }, session);
  return subscription;
}
async function cancelSubscription(session, id, cancelRequest, query) {
  const {
    subscription
  } = await rechargeApiRequest("post", `/subscriptions/${id}/cancel`, {
    data: cancelRequest,
    query
  }, session);
  return subscription;
}
async function activateSubscription(session, id, query) {
  const {
    subscription
  } = await rechargeApiRequest("post", `/subscriptions/${id}/activate`, {
    query
  }, session);
  return subscription;
}
async function skipSubscriptionCharge(session, id, date) {
  const {
    charge
  } = await rechargeApiRequest("post", `/subscriptions/${id}/charges/skip`, {
    data: {
      date,
      subscription_id: `${id}`
    }
  }, session);
  return charge;
}
async function skipGiftSubscriptionCharge(session, subscriptionIds, recipientAddress) {
  const {
    onetimes
  } = await rechargeApiRequest("post", "/purchase_items/skip_gift", {
    data: {
      purchase_item_ids: subscriptionIds.map(Number),
      recipient_address: recipientAddress
    }
  }, session);
  return onetimes;
}
async function createSubscriptions(session, createRequestBulk) {
  const length = createRequestBulk.length;
  if (length < 1 || length > 21) {
    throw new Error("Number of subscriptions must be between 1 and 20.");
  }
  const {
    customerId
  } = session;
  if (!customerId) {
    throw new Error("No customerId in session.");
  }
  const addressId = createRequestBulk[0].address_id;
  if (!createRequestBulk.every(createRequest => createRequest.address_id === addressId)) {
    throw new Error("All subscriptions must have the same address_id.");
  }
  const bulkSubscriptionMapperPartial = partial(bulkSubscriptionCreateMapper, customerId);
  const requestData = createRequestBulk.map(bulkSubscriptionMapperPartial);
  const {
    subscriptions
  } = await rechargeApiRequest("post", `/addresses/${addressId}/subscriptions-bulk`, {
    data: {
      subscriptions: requestData
    },
    headers: {
      "X-Recharge-Version": "2021-01"
    }
  }, session);
  return subscriptions.map(subscriptionMapperOldToNew);
}
async function updateSubscriptions(session, addressId, updateRequestBulk, query) {
  const length = updateRequestBulk.length;
  if (length < 1 || length > 21) {
    throw new Error("Number of subscriptions must be between 1 and 20.");
  }
  const {
    customerId
  } = session;
  if (!customerId) {
    throw new Error("No customerId in session.");
  }
  const bulkSubscriptionMapperPartial = partial(bulkSubscriptionUpdateMapper, !!query?.force_update);
  const requestData = updateRequestBulk.map(bulkSubscriptionMapperPartial);
  const {
    subscriptions
  } = await rechargeApiRequest("put", `/addresses/${addressId}/subscriptions-bulk`, {
    data: {
      subscriptions: requestData
    },
    headers: {
      "X-Recharge-Version": "2021-01"
    }
  }, session);
  return subscriptions.map(subscriptionMapperOldToNew);
}
export { activateSubscription, cancelSubscription, createSubscription, createSubscriptions, getSubscription, listSubscriptions, skipGiftSubscriptionCharge, skipSubscriptionCharge, updateSubscription, updateSubscriptionAddress, updateSubscriptionChargeDate, updateSubscriptions };